
export const rmsConstants = {
    RMS_API: "v1/portfolio/rms",
    RMS_SAGA: "RMS_SAGA",
    RMS_REQUEST: "RMS_REQUEST",
    RMS_RESPONSE: "RMS_RESPONSE",
    RESET_RMS_DATA: "RESET_RMS_DATA"
}